module.exports = __webpack_public_path__ + "static/img/product.0f56736.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product.jpg
// module id = m2rK
// module chunks = 1